// MUST stay first: wipes incompatible localStorage (version-gated) before any
// store module is evaluated and reads stale data into memory.
import './clearLegacyStorageOnBoot';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { AppProvider } from '@pixi/react';
import * as PIXI from 'pixi.js';
import App from './App';
import { seedStarter } from './store/loadoutSlice';
import { seedDefaultNpcUnlocks } from './store/npcSlice';
import { seedDefaultUnlockedDungeons } from './store/unlockedDungeonsSlice';
import { initClientErrorReporter } from './services/clientErrorReporter';
import { configurePixiDefaults, loadUiFont } from './bootstrap/pixi';
import './App.css';
import './style.scss';
import './styles/typography.scss';
import './styles/menu.scss';

// DEV: pipe uncaught errors / rejections / console.error to logs/client.log.
initClientErrorReporter();

seedStarter();
seedDefaultNpcUnlocks();
seedDefaultUnlockedDungeons();

configurePixiDefaults();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
const app = new PIXI.Application();

// Wait for the font to load before the first render — Pixi rasterizes text
// once at Text creation, so a fallback shown at boot would stay on screen
// until the Text is rebuilt.
const fontReady = loadUiFont();

fontReady.then(() => {
  root.render(
    <AppProvider value={app}>
      <div className="App">
        <App />
      </div>
    </AppProvider>,
  );
});
